(function(root){"use strict";var CARDS={"card-twh73y0r":{back:"https://pocketfactory-brand.bryton-p-zoz.workers.dev/v1/assets/asset_a0acae4153c14948aacd44506c81fdf8/content",front:"https://pocketfactory-brand.bryton-p-zoz.workers.dev/v1/assets/asset_8eb8ff6f06d24e328e84481c4fcea8a6/content"}};var id="";try{id=new URLSearchParams(root.location.search).get("card")||""}catch(_){}var c=CARDS[id];if(!c)return;var doc=root.document;function paint(){if(!doc.getElementById("pf-img-back-css")){var st=doc.createElement("style");st.id="pf-img-back-css";st.textContent="html[data-pf-img-back] [data-side=\"back\"] [data-card-art]{visibility:hidden!important}.pf-img-back{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;z-index:2;pointer-events:none}";doc.head.appendChild(st);doc.documentElement.setAttribute("data-pf-img-back","")}doc.querySelectorAll('[data-side="back"]').forEach(function(card){if(card.querySelector(":scope>.pf-img-back"))return;if(root.getComputedStyle(card).position==="static")card.style.position="relative";var im=doc.createElement("img");im.className="pf-img-back";im.alt="Card back: your artwork";im.src=c.back;card.appendChild(im)});doc.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){[["Back image",c.back],["Front image",c.front]].forEach(function(p){if(f.querySelector('input[name="properties['+p[0]+']"]'))return;var i=doc.createElement("input");i.type="hidden";i.name="properties["+p[0]+"]";i.value=p[1];f.appendChild(i)})})}var n=0,t=setInterval(function(){try{paint()}catch(_){}if(++n>40)clearInterval(t)},500);doc.readyState==="loading"?doc.addEventListener("DOMContentLoaded",paint):paint()})(window);
/**
 * Stream B — shareable preview hydrate.
 * Reads ?pf_preview=TOKEN, loads public snapshot from pocketfactory-brand,
 * applies brand into the existing PocketPersonalization store / card renderer.
 * Fail soft: any error leaves the normal storefront entry flow.
 * No secrets in theme. No recipient email in URL. Prices stay live Shopify.
 */
(function (root) {
  "use strict";
  // pocket-core.js names the Worker; it loads after this deferred script, so ask at request time.
  function endpoint() {
    return root.PocketCore.workerBase() + "/v1/previews/";
  }
  // Approved layout for a preview whose saved snapshot predates it (CHRONOSCOPY proof is vertical).
  var LAYOUT = { prv_5e09b91e2c2142f2af67880a92db43c1: "Vertical" };
  var TOKEN_RE = /^pfprev_[a-f0-9]{64}$/;

  function paramToken() {
    try {
      return new URLSearchParams(root.location.search).get("pf_preview") || "";
    } catch (_) {
      return "";
    }
  }

  var token = paramToken();
  if (!TOKEN_RE.test(token)) return;

  // Suppress welcome dialog until hydrate finishes (or fails soft).
  root.__PF_PREVIEW_BOOT__ = true;
  root.document.documentElement.setAttribute("data-pf-preview", "loading");

  function failSoft(reason) {
    root.__PF_PREVIEW_BOOT__ = false;
    root.document.documentElement.setAttribute("data-pf-preview", "failed");
    root.document.documentElement.setAttribute("data-pf-preview-reason", String(reason || "error").slice(0, 80));
    // Do not auto-open dialog; visitor can still enter a website normally.
  }

  function brandFromSnapshot(snap) {
    var b = snap && snap.business ? snap.business : {};
    var domain = b.domain || "";
    try {
      if (!domain && b.website) domain = new URL(b.website).hostname.replace(/^www\./, "");
    } catch (_) {}
    return {
      schemaVersion: snap.schemaVersion || "1.4.0",
      pipelineVersion: "prep-v1",
      readiness: { state: "ready" },
      domain: domain,
      businessName: b.name || domain || "Business",
      websiteUrl: b.website || (domain ? "https://" + domain : null),
      logoMarkUrl: b.logoMarkUrl || null,
      wordmarkUrl: b.wordmarkUrl || null,
      combinedLogoUrl: b.combinedLogoUrl || null,
      primaryColor: b.primaryColor || null,
      secondaryColor: b.secondaryColor || null,
      artwork: b.artwork || null,
      source: "tinyfish",
      confidence: {},
      socialLinks: {},
      bookingUrl: null,
      phone: null,
      email: null,
      address: null,
      fetchedAt: snap.createdAt || null,
      preview: {
        tokenPresent: true,
        useCase: snap.useCase || null,
        destination: snap.destination || null,
        card: snap.card || null,
        pack: snap.pack || null,
        rendererVersion: snap.rendererVersion || null,
        destinationStatus: (snap.destination && snap.destination.status) || "unverified",
      },
    };
  }


  // HOTFIX-PREVIEW-2 (owner, Oct 28): CHRONOSCOPY preview only. Her three lines replace the tap symbol + QR on the 3D card back.
  var BACK = { prv_5e09b91e2c2142f2af67880a92db43c1: ["chronoscopy.art", "Yara Fostiak", "+1 747 350 7885"] };
  function applyBack(snap) {
    var lines = BACK[snap && snap.previewId];
    if (!lines) return;
    var doc = root.document;
    var fl = doc.createElement("link");
    fl.rel = "stylesheet"; fl.href = "https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@300&display=swap";
    doc.head.appendChild(fl);
    var st = doc.createElement("style");
    st.textContent = "html[data-pf-custom-back] [data-card-art]{visibility:hidden!important}" +
      ".pf-custom-back{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.9em;color:#f2f2f2;font:300 10px/1.2 'Josefin Sans','Helvetica Neue',Arial,sans-serif;letter-spacing:.22em;padding-left:.22em;text-align:center;pointer-events:none;z-index:2}";
    doc.head.appendChild(st);
    doc.documentElement.setAttribute("data-pf-custom-back", "");
    var paint = function () {
      doc.querySelectorAll("[data-card-art]").forEach(function (art) {
        var card = art.closest('[data-side="back"]') || art.parentElement;
        if (!card || card.querySelector(":scope>.pf-custom-back")) return;
        if (root.getComputedStyle(card).position === "static") card.style.position = "relative";
        var box = doc.createElement("div");
        box.className = "pf-custom-back";
        lines.forEach(function (t) { var d = doc.createElement("div"); d.textContent = t; box.appendChild(d); });
        card.appendChild(box);
      });
      doc.querySelectorAll(".pf-custom-back").forEach(function (box) {
        var w = box.parentElement.offsetWidth;
        if (w) box.style.fontSize = (w * 0.052).toFixed(2) + "px";
      });
      doc.querySelectorAll("body *").forEach(function (el) {
        if (el.children.length > 3 || el.closest(".pf-custom-back")) return;
        var t = (el.textContent || "").replace(/\s+/g, " ").trim();
        if (/^tap ?\+? ?qr$/i.test(t)) el.style.display = "none";
      });
      doc.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        if (f.querySelector('input[name="properties[Back text]"]')) return;
        var i = doc.createElement("input");
        i.type = "hidden"; i.name = "properties[Back text]"; i.value = lines.join(" / ");
        f.appendChild(i);
      });
    };
    paint();
    [300, 1000, 2500, 5000, 8000].forEach(function (ms) { root.setTimeout(paint, ms); });
  }

  function applyDraft(snap) {
    var draft = {
      useCase: snap.useCase || null,
      destination: snap.destination || null,
      card: snap.card || null,
      pack: snap.pack || null,
    };
    try {
      root.sessionStorage.setItem("pf.preview.draft.v1", JSON.stringify(draft));
    } catch (_) {}

    // Best-effort: select matching purpose / finish controls if present.
    try {
      if (snap.useCase) {
        var purpose = root.document.querySelector('[data-purpose="' + snap.useCase + '"], [data-pf-purpose="' + snap.useCase + '"]');
        if (purpose) purpose.click();
      }
      // HOTFIX-PREVIEW-1: apply the saved card (layout, background, edge color, finish) and pack size, not only the finish.
      var doc = root.document, card = snap.card || {}, pack = snap.pack || {};
      var setRadio = function (name, value) {
        if (!value) return;
        var r = doc.querySelector('input[type="radio"][name="properties[' + name + ']"][value="' + value + '"]');
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new root.Event("change", { bubbles: true }));
        }
      };
      var cap = function (v) { v = String(v || ""); return v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : ""; };
      setRadio("Orientation", LAYOUT[snap.previewId] || cap(card.orientation));
      var base = cap(card.base);
      setRadio("Card base", base === "Black" ? "Dark" : base === "White" ? "Light" : base);
      setRadio("Edge color", base === "Black" || base === "White" ? base : cap(card.edge));
      setRadio("Finish", pack.finish || card.finish);
      var size = Number(pack.size) || 0;
      var select = size && doc.querySelector('form [data-pack], [data-pack]');
      if (select && select.value !== String(size) && select.querySelector('option[value="' + size + '"]')) {
        select.value = String(size);
        select.dispatchEvent(new root.Event("change", { bubbles: true }));
      }
    } catch (_) {}

    root.document.dispatchEvent(
      new root.CustomEvent("pocket:preview-hydrated", {
        detail: { snapshot: snap, draft: draft },
      }),
    );
  }

  function applyBrand(brand) {
    var store = root.PocketPersonalization && root.PocketPersonalization.store;
    if (!store || typeof store.setBrand !== "function") {
      // Personalization not ready yet — retry briefly.
      return false;
    }
    try {
      // normalizeBrand via brand service when available
      var normalized = root.PocketBrandService && root.PocketBrandService.normalizeBrand
        ? root.PocketBrandService.normalizeBrand(brand)
        : brand;
      store.setBrand(normalized);
      return true;
    } catch (_) {
      try {
        store.setBrand(brand);
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  function hydrate(snap) {
    var brand = brandFromSnapshot(snap);
    var tries = 0;
    function attempt() {
      tries += 1;
      if (applyBrand(brand)) {
        applyDraft(snap);
        try { applyBack(snap); } catch (_) {}
        root.__PF_PREVIEW_BOOT__ = false;
        root.document.documentElement.setAttribute("data-pf-preview", "ready");
        root.document.documentElement.setAttribute("data-pf-personalized", "");
        return;
      }
      if (tries < 40) root.setTimeout(attempt, 50);
      else failSoft("store_unavailable");
    }
    attempt();
  }

  function load() {
    root.Promise.resolve()
      .then(function () {
        return root.fetch(endpoint() + encodeURIComponent(token), {
          method: "GET",
          credentials: "omit",
          headers: { Accept: "application/json" },
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("preview_http_" + res.status);
        return res.json();
      })
      .then(hydrate)
      .catch(function (err) {
        failSoft((err && err.message) || "fetch_failed");
      });
  }
  if (root.PocketCore) load();
  else root.document.addEventListener("DOMContentLoaded", load, { once: true });
})(typeof window !== "undefined" ? window : this);
